/**
 * Utility functions for navigation and routing
 */

/**
 * Get the appropriate dashboard path based on user role
 * @param {string} role - User role
 * @returns {string} Dashboard path
 */
export function getDashboardPath(role) {
  switch (role) {
    case 'Doctor':
      return '/doctor/dashboard';
    case 'Admin':
      return '/dashboard'; // This should go to the main dashboard, not admin-specific
    case 'Nurse':
      return '/nurse/dashboard';
    case 'Receptionist':
      return '/receptionist/dashboard';
    default:
      return '/dashboard';
  }
}

/**
 * Auth routes that authenticated users should not access
 */
export const AUTH_ROUTES = [
  '/signin', 
  '/signup', 
  '/forgot', 
  '/verify-otp', 
  '/reset-password', 
  '/'
];

/**
 * Check if a path is an auth route
 * @param {string} path - Current path
 * @returns {boolean} True if auth route
 */
export function isAuthRoute(path) {
  return AUTH_ROUTES.includes(path);
}

/**
 * Prevent back navigation to auth pages by managing browser history
 * @param {Object} user - Current user object
 */
export function preventAuthNavigation(user) {
  if (!user || typeof window === 'undefined') return;

  const currentPath = window.location.pathname;
  
  if (isAuthRoute(currentPath)) {
    const dashboardPath = getDashboardPath(user.role);
    window.history.replaceState(null, '', dashboardPath);
  }
}